var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 48,
    viewBox: "0 0 34 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 48H3C1.3 48 0 46.7 0 45V9C0 7.3 1.3 6 3 6H7C7.6 6 8 6.4 8 7C8 7.6 7.6 8 7 8H3C2.4 8 2 8.4 2 9V45C2 45.6 2.4 46 3 46H31C31.6 46 32 45.6 32 45V9C32 8.4 31.6 8 31 8H27C26.4 8 26 7.6 26 7C26 6.4 26.4 6 27 6H31C32.7 6 34 7.3 34 9V45C34 46.7 32.7 48 31 48Z",
    fill: "#A66304"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10H5.99995C5.69995 10 5.29995 9.8 5.09995 9.5C4.89995 9.2 4.89995 8.8 5.09995 8.5L8.09995 2.5C8.29995 2.2 8.59995 2 8.99995 2H14.2C14.6 0.8 15.7 0 17 0C18.3 0 19.4 0.8 19.7999 2H25C25.4 2 25.7 2.2 25.9 2.6L28.9 8.6C29.1 8.9 29 9.3 28.9 9.6C28.7 9.8 28.2999 10 28 10ZM7.59995 8H26.4L24.4 4H19C18.4 4 18 3.6 18 3C18 2.4 17.6 2 17 2C16.4 2 16 2.4 16 3C16 3.6 15.6 4 15 4H9.59995L7.59995 8Z",
    fill: "#A66304"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20C17.9 20 17.9 20 17.8 20C17.5 19.9 17.2 19.7 17.1 19.5L15.7 16.7L14.7 17.7C14.5 17.9 14.3 18 14 18H12C11.4 18 11 17.6 11 17C11 16.4 11.4 16 12 16H13.6L15.3 14.3C15.5 14.1 15.9 14 16.2 14C16.5 14.1 16.8 14.3 16.9 14.5L18.3 17.3L19.3 16.3C19.5 16.1 19.7 16 20 16H22C22.6 16 23 16.4 23 17C23 17.6 22.6 18 22 18H20.4L18.7 19.7C18.5 19.9 18.3 20 18 20Z",
    fill: "#A66304"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 24H5C4.4 24 4 23.6 4 23C4 22.4 4.4 22 5 22H29C29.6 22 30 22.4 30 23C30 23.6 29.6 24 29 24Z",
    fill: "#A66304"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 29H5C4.4 29 4 28.6 4 28C4 27.4 4.4 27 5 27H29C29.6 27 30 27.4 30 28C30 28.6 29.6 29 29 29Z",
    fill: "#A66304"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 34H5C4.4 34 4 33.6 4 33C4 32.4 4.4 32 5 32H29C29.6 32 30 32.4 30 33C30 33.6 29.6 34 29 34Z",
    fill: "#A66304"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 39H5C4.4 39 4 38.6 4 38C4 37.4 4.4 37 5 37H23C23.6 37 24 37.4 24 38C24 38.6 23.6 39 23 39Z",
    fill: "#A66304"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseStatus);
export default __webpack_public_path__ + "static/media/Case_status.b3094c9fd6ac2c648cd49e6a4fb3e501.svg";
export { ForwardRef as ReactComponent };